import Api from './Api';

class DatabaseCollectionsApi extends Api {
  url = 'collections';
}

const singleton = new DatabaseCollectionsApi();
export default singleton;
